@if (shortVersion === false) {
  <div class="grid-x grid-margin-x teaser">
    <h1
      class="cell small-12 medium-offset-1 medium-10 text-center">{{ 'moderat.einstieg.stepheadline' | translate: welcomePlaceholder }}</h1>
    <div class="cell small-12 medium-offset-2 medium-3">
      <app-advisor-image path="/moc/moc-teaser.svg"></app-advisor-image>
    </div>
    <div class="cell small-12 medium-5">
      <div class="callout" [innerHTML]="'moderat.einstieg.teaser' | translate"></div>
    </div>
  </div>
}

<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <fieldset class="grid-x grid-margin-x check-wrapper">
      <legend class="cell small-12 medium-offset-1 medium-10">{{ 'moderat.einstieg.selection.headline' | translate }}</legend>
      @for(interest of interestList; track interest) {
        <div class="cell xsmall-12 small-6 medium-5">
          <div class="radio-button">
            <input type="radio" name="interesse" [id]="'interesse_' + interest" [value]="interest" formControlName="interesse"
              [attr.aria-expanded]="form?.get('interesse').value === interest" [attr.aria-controls]="'button-teaser' + (interest === 'massnahme'? ' selection_' + interest : '')">
            <label [for]="'interesse_' + interest" (click)="interestSelected()">
              <app-advisor-image [path]="'/moc/moc-einstieg-' + interest + '.svg'"></app-advisor-image>
              <span [innerHTML]="'moderat.einstieg.interesse.' + interest | translate"></span>
            </label>
          </div>
        </div>
      }
    </fieldset>

  <div #submitWrapper>
    @if (form?.get('interesse').value === 'massnahme') {
      <div id="selection_massnahme" class="massnahmen-wrapper">
        <fieldset class="grid-x grid-margin-x grid-margin-y check-wrapper">
          <legend class="cell small-12 medium-offset-1 medium-10">{{ 'moderat.einstieg.interesse.headline' | translate }}</legend>
          @for (measure of measureList; track measure) {
            <div class="cell small-12 medium-5">
              <mat-checkbox (change)="selectMeasure($event)" [value]="measure" [checked]="hasMeasure(measure)"
                            class="checkbox-button" color="primary">{{ 'moderat.massnahme.' + measure | translate }}
              </mat-checkbox>
            </div>
          }
        </fieldset>
      </div>
    }

    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-offset-1 medium-10">
        <div id="button-teaser" class="button-wrapper" [class.background]="form?.get('interesse').valid">
          @if (form.get('interesse').valid) {
            <div [innerHTML]="'moderat.einstieg.submit.teaser.' + form.get('interesse').value | translate"></div>
          }
          @if (showError && form.valid === false) {
            <div role="alert" class="form-errors" [innerHTML]="'moderat.einstieg.submit.teaser.error' | translate"></div>
          }
          @if (shortVersion === false) {
            <button type="submit" class="button inline-arrow-right" (click)="form.valid ? onSubmitClick() : null" [class.disabled]="!form.valid">{{ 'moderat.einstieg.submit' | translate }}</button>
          }
          @if (shortVersion === true) {
            <a role="button" [href]="shortVersionButtonUrl" (click)="saveData()" [class.disabled]="!form.valid" class="button inline-arrow-right" target="_blank">{{ 'moderat.einstieg.submit' | translate }}</a>
          }
        </div>
      </div>
    </div>
  </div>
</form>

